import React, {forwardRef, PropsWithChildren} from "react";

import SlickSlider, {SliderType} from "@pg-mono/slick-slider";

interface IProps extends PropsWithChildren {
    ready?: boolean;
    reelsCount: number;
    afterChange?: (slideIndex: number) => void;
}

export const ReelSlider = forwardRef<SliderType, IProps>((props, sliderRef) => {
    return (
        <SlickSlider
            ref={sliderRef}
            vertical
            verticalSwiping
            infinite={props.reelsCount > 1}
            slidesToShow={1}
            slidesToScroll={1}
            arrows={false}
            afterChange={props.afterChange}
        >
            {props.ready ? props.children : null}
        </SlickSlider>
    );
});
import React, {forwardRef, PropsWithChildren} from "react";

import SlickSlider, {SliderType} from "@pg-mono/slick-slider";

interface IProps extends PropsWithChildren {
    ready?: boolean;
    reelsCount: number;
    afterChange?: (slideIndex: number) => void;
}

export const ReelSlider = forwardRef<SliderType, IProps>((props, sliderRef) => {
    return (
        <SlickSlider
            ref={sliderRef}
            vertical
            verticalSwiping
            infinite={props.reelsCount > 1}
            slidesToShow={1}
            slidesToScroll={1}
            arrows={false}
            afterChange={props.afterChange}
        >
            {props.ready ? props.children : null}
        </SlickSlider>
    );
});
